import { ChangeEvent, MutableRefObject } from 'react';
import styled from 'styled-components';
import { Loading } from '../loading/Loading';
import { usePostImageMutation } from '../../../hooks/api/etc/upload/mutations/usePostImage.mutation';

interface ImageUploaderProps {
  inputId: string;
  successHandler: (fileUrl: string) => void;
  errorHandler: () => void;
  inputRef?: MutableRefObject<HTMLInputElement | null>;
  category: string;
}

export const ImageUploader = ({ inputId, successHandler, errorHandler, inputRef, category }: ImageUploaderProps) => {
  const { mutate: postImage, isLoading: isImageUploading } = usePostImageMutation();

  const uploadImage = async (event: ChangeEvent<HTMLInputElement>) => {
    const imageFile: File | null = event.target.files ? event.target.files[0] : null;

    const resetInputValue = () => {
      event.target.value = '';
    };

    if (imageFile) {
      postImage(
        { category, reqBody: { file: imageFile } },
        {
          onSuccess: (res) => successHandler(res.url),
          onError: () => {
            errorHandler();
            resetInputValue();
          },
        },
      );
    }
  };

  return (
    <>
      <Uploader>
        <Label htmlFor={inputId} />
        <Input
          id={inputId}
          type={'file'}
          accept={'image/*'}
          onChange={(e: ChangeEvent<HTMLInputElement>) => uploadImage(e)}
          ref={inputRef}
        />
      </Uploader>

      <Loading loading={isImageUploading} />
    </>
  );
};

const Uploader = styled.div`
  position: absolute;

  top: 0;
  left: 0;

  width: 100%;
  height: 100%;
`;

const Label = styled.label`
  width: 100%;
  height: 100%;

  display: flex;

  cursor: pointer;
`;

const Input = styled.input`
  position: absolute;

  width: 1px;
  height: 1px;

  padding: 0;

  margin: -1px;

  overflow: hidden;

  clip: rect(0, 0, 0, 0);
  border: 0;
`;
